(function(root, factory) {
    'use strict';
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory(require('@ali/resource'));
    } else {
        // Global Variables
        root.UEM = root.UEM || {};
        root.UEM.fit = factory(root.UEM.resource);
    }

}(window, function(resource) {
    'use strict';
    window.UEM = window.UEM || {};
    var ua = detectUA();
    var out = {},
        resizeJob = window.UEM.resizeJob = window.UEM.resizeJob || [],
        resizeOnceJob = window.UEM.resizeOnceJob = window.UEM.resizeOnceJob || [],
        converFactor;

    function init(desingWidth) {
        converFactor = desingWidth / 1000;
    }

    init(640);

    //position fit definition------------start-----------
    var scaleRatioW = null;
    var scaleRatioH = null;
    var widthPsdDef = 640;
    var heightPsdDef = 1136;
    var winWidth = null;
    var winHeight = null;
    var VERTICAL_TOP = 'top';
    var VERTICAL_MIDDLE = 'middle';
    var VERTICAL_BOTTOM = 'bottom';
    var ALGIN_LEFT = 'left';
    var ALGIN_CENTER = 'center';
    var ALGIN_RIGHT = 'right';
    //position fit definition------------end-----------

    //position fit exports and function------------start-----------
    out.VERTICAL_TOP = VERTICAL_TOP;
    out.VERTICAL_MIDDLE = VERTICAL_MIDDLE;
    out.VERTICAL_BOTTOM = VERTICAL_BOTTOM;
    out.ALGIN_LEFT = ALGIN_LEFT;
    out.ALGIN_CENTER = ALGIN_CENTER;
    out.ALGIN_RIGHT = ALGIN_RIGHT;

    out.stretch = function(op) {
        op.widthPsd = getDef('widthPsd', op, widthPsdDef);
        op.heightPsd = getDef('heightPsd', op, heightPsdDef);
        var reObj = {};
        var scaleW = reObj.zoomX = getScaleRatioWidth(op.widthPsd);
        var scaleH = reObj.zoomY = getScaleRatioHeight(op.heightPsd);
        reObj.width = op.width * scaleW;
        reObj.height = op.height * scaleH;
        reObj.x = op.x * scaleW;
        reObj.y = op.y * scaleH;
        return reObj;
    };

    out.beIn = function(op) {
        op.widthPsd = getDef('widthPsd', op, widthPsdDef);
        op.heightPsd = getDef('heightPsd', op, heightPsdDef);
        var reObj = {};
        var scale = reObj.zoomX = reObj.zoomY = op.zoomH ? getScaleRatioHeight(op.heightPsd) : getScaleRatioWidth(op.widthPsd);
        reObj.width = op.width * scale;
        reObj.height = op.height * scale;
        reObj.x = op.x / op.widthPsd * getWinWidth();
        reObj.y = op.y / op.heightPsd * getWinHeight();
        return reObj;
    };

    out.zoomWidth = function(op) {
        op.widthPsd = getDef('widthPsd', op, widthPsdDef);
        op.heightPsd = getDef('heightPsd', op, heightPsdDef);
        op.vertical = getDef('vertical', op, VERTICAL_TOP);
        return zoomWidthAlign(op);
    };

    out.zoomHeight = function(op) {
        op.widthPsd = getDef('widthPsd', op, widthPsdDef);
        op.heightPsd = getDef('heightPsd', op, heightPsdDef);
        op.algin = getDef('algin', op, ALGIN_LEFT);
        return zoomHeightVertical(op);
    };

    function zoomWidthAlign(op) {
        var reObj = {};
        var scale = reObj.zoomX = reObj.zoomY = getScaleRatioWidth(op.widthPsd);
        reObj.width = op.width * scale;
        reObj.height = op.height * scale;
        reObj.x = op.x * scale;
        switch (op.vertical) {
            case VERTICAL_TOP:
                reObj.y = op.y * scale;
                break;
            case VERTICAL_MIDDLE:
                reObj.y = getWinHeight() / 2 - (op.heightPsd / 2 - op.y) * scale;
                break;
            default:
                reObj.y = getWinHeight() - (op.heightPsd - op.y) * scale;
                break;
        }
        return reObj;
    }

    function zoomHeightVertical(op) {
        var reObj = {};
        var scale = reObj.zoomX = reObj.zoomY = getScaleRatioHeight(op.heightPsd);
        reObj.width = op.width * scale;
        reObj.height = op.height * scale;
        switch (op.algin) {
            case ALGIN_LEFT:
                reObj.x = op.x * scale;
                break;
            case ALGIN_CENTER:
                reObj.x = getWinWidth() / 2 - (op.widthPsd / 2 - op.x) * scale;
                break;
            default:
                reObj.x = getWinWidth() - (op.widthPsd - op.x) * scale;
                break;
        }
        reObj.y = op.y * scale;
        return reObj;
    }

    function getScaleRatioWidth(widthPsd) {
        if (scaleRatioW !== null) {
            return scaleRatioW;
        } else {
            return (scaleRatioW = getWinWidth() / (widthPsd ? widthPsd : widthPsdDef));
        }
    }

    function getScaleRatioHeight(heightPsd) {
        if (scaleRatioH !== null) {
            return scaleRatioH;
        } else {
            return (scaleRatioH = getWinHeight() / (heightPsd ? heightPsd : heightPsdDef));
        }
    }

    function getWinWidth() {
        if (winWidth !== null) {
            return winWidth;
        } else {
            return (winWidth = window.innerWidth);
        }
    }

    function getWinHeight() {
        if (winHeight !== null) {
            return winHeight;
        } else {
            return (winHeight = window.innerHeight);
        }
    }

    function getDef(key, op, def) {
        return op.hasOwnProperty(key) ? op[key] : def;
    }

    //position fit exports and function------------end-----------

    //other fit exports and function------------start-----------
    /**
     * export resize job
     */
    out.resizeJob = resizeJob;
    out.resizeOnceJob = resizeOnceJob;

    /**
     * ban landscape orientation
     */
    var banLandscapeOrientationMask;
    out.banLandscapeOrientation = function(opt) {
        if (ua.os !== 'OTHERS') {
            opt = opt || {};
            var banLandscapeOrientationStyle = document.createElement('style');
            banLandscapeOrientationMask = document.createElement('div');
            var style = [
                '.banLandscapeOrientationMask {',
                'position: fixed;',
                'top: 0;',
                'left: 0;',
                'width: 100%;',
                'height: 100%;',
                'background: ' + (opt.bg ? opt.bg : '#1a1a1a') + ';',
                'display: none;',
                'z-index: 999;',
                '}',
                '.banLandscapeOrientationMask .landscape-box {',
                'position:absolute;',
                'top:50%;',
                'left:50%;',
                'color:' + (opt.color ? opt.color : '#9aa29b') + ';',
                'font-size: 15px;',
                'white-space: nowrap;',
                '-webkit-transform:translate(-50%,-50%);',
                '}',
                '.banLandscapeOrientationMask .landscape-icon{',
                'display:inline-block;',
                'width:49px;',
                'height:46px;',
                'background:url("//image.uc.cn/s/uae/g/01/fit/icon_rotate.png") no-repeat;',
                'background-size:49px 46px;',
                '}',
                '.banLandscapeOrientationMask p{',
                'margin-left:10px;',
                'display:inline-block;',
                'vertical-align: 76%;',
                '}',
                '@media all and (orientation: landscape) {',
                '.banLandscapeOrientationMask {',
                // 'display: -webkit-box;',
                '-webkit-box-orient: horizontal;',
                '-webkit-box-pack: center;',
                '-webkit-box-align: center;',
                '}',
                '}'
            ];
            banLandscapeOrientationStyle.innerHTML = style.join('');
            banLandscapeOrientationMask.className = 'banLandscapeOrientationMask';
            banLandscapeOrientationMask.innerHTML = '<div class="landscape-box"><div class="landscape-icon"></div><p>竖屏观看获得最佳体验！</p></div>';
            document.body.appendChild(banLandscapeOrientationStyle);
            document.body.appendChild(banLandscapeOrientationMask);
            window.addEventListener('orientationchange', function() {
                // console.log("the orientation of the device is now " + screen.orientation.angle);
                if (window.orientation === 90 || window.orientation === -90) {
                  banLandscapeOrientationMask.style.display = '-webkit-box';
                } else {
                  banLandscapeOrientationMask.style.display = 'none';
                }
            });
        }
    };

    out.banLandscapeOrientationDisable = function() {
        if (banLandscapeOrientationMask) {
            banLandscapeOrientationMask.style.display = 'none';
        }
    };

    out.banLandscapeOrientationEnable = function() {
        if (banLandscapeOrientationMask) {
            banLandscapeOrientationMask.removeAttribute('style');
        }
    };

    /**
     * adapt window by using rem
     */
    function rem(desingWidth) {
        calculateRootFontSize(desingWidth);
        resizeJob.push(function() {
            calculateRootFontSize(desingWidth);
        });
        compatibleSystemFontSettings();
    }

    /**
     * calculate root font size for css rem
     */
    function calculateRootFontSize(desingWidth) {
        setFontSizePixel(desingWidth);
        setTimeout(function() {
            setFontSizePixel(desingWidth);
        }, 100); // safari浏览器 innerWidth 第一次获取为实际屏幕像素点
    }

    /**
     * set html font size pixel
     */
    function setFontSizePixel(desingWidth) {
        if (desingWidth) {
            init(desingWidth);
        }
        var htmlFontSize = window.innerWidth / converFactor;
        setHtmlTagFontSizePixel(htmlFontSize);
    }

    function compatibleSystemFontSettings() {
        if (ua.os === 'ANDROID' && ua.pf === 'UC') {
            setTimeout(function() {
                var htmlFontSize = window.innerWidth / converFactor;
                var el = document.getElementsByTagName('html')[0];
                var htmlFontSizeComputedStyle = parseInt(window.getComputedStyle(el).fontSize);
                if (Math.abs(htmlFontSizeComputedStyle - htmlFontSize) > 10) {
                    setHtmlTagFontSizePixel(htmlFontSize * htmlFontSize / htmlFontSizeComputedStyle);
                }
            }, 500);
        }
    }

    function setHtmlTagFontSizePixel(fontSize) {
        document.querySelector('html').style.fontSize = fontSize + 'px';
    }

    rem();
    out.rem = rem;

    window.onresize = function() {
        var i = resizeJob.length;
        while (i--) {
            resizeJobRender(resizeJob[i]);
        }
        var j = resizeOnceJob.length;
        while (j--) {
            if (resizeOnceJob[j].implement) {
                resizeOnceJobRender(resizeOnceJob[j]);
            }
        }
    };

    /**
     * convert rem value to pixel value
     */
    out.calculatePixel = function(remValue) {
        return parseInt(remValue * window.innerWidth / converFactor, 10);
    };

    /**
     * convert rem value to pixel value
     */
    out.calculateRem = function(pxValue) {
        return pxValue * converFactor / window.innerWidth;
    };

    //other fit exports and function------------end-----------


    //横屏杀手
    out.crossKiller = function(cb) {
        if (ua.os !== 'OTHERS' && window.innerHeight > window.innerWidth) {
            cb();
        } else {
            cb.implement = true;
            out.resizeOnceJob.push(cb);
        }
    };

    function resizeOnceJobRender(cb) {
        clearTimeout(cb.st);
        cb.st = setTimeout(function() {
            cb.implement = false;
            cb();
        }, 50);
    }

    function resizeJobRender(cb) {
        clearTimeout(cb.st);
        cb.st = setTimeout(function() {
            cb();
        }, 50);
    }

    function detectUA() {
        var ua = window.navigator.userAgent.toLowerCase();
        var getOS = function() {
            if (/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua)) {
                return 'IOS';
            }
            return ua.indexOf('android') > 1 ? 'ANDROID' : 'OTHERS';
        };
        var getPF = function() {
            if (ua.indexOf('ucbrowser') >= 0) {
                return 'UC';
            }
            return 'OTHERS';
        };

        return {
            os: getOS(),
            pf: getPF()
        };
    }

    // loading模板
    out.loading = function(opt, loadedCb, loadingCb) {
        opt = opt || {};
        var loadingStyle = document.createElement('style');
        var loadingMask = document.createElement('div');
        var style = [
            '.fit-loading {',
            'position: fixed;',
            'top: 0;',
            'left: 0;',
            'width: 100%;',
            'height: 100%;',
            'background: ' + (opt.bg ? opt.bg : '#1a1a1a') + ';',
            'z-index: 999;',
            '}',
            '.fit-loading .loading-box {',
            'position: absolute;',
            'top: 50%;',
            'left: 50%;',
            'width: 36px;',
            'height: 21px;',
            'transform: translate3d(-50%, -50%, 0);',
            'background: url("//image.uc.cn/s/uae/g/01/fit/loading_v1.png") no-repeat;',
            'background-size: 364px 21px;',
            '-webkit-animation: fitLoading 0.7s steps(8) infinite;',
            '}',
            '@-webkit-keyframes fitLoading {',
            '0% {}',
            '100% {background-position: -328px 0;}',
            '}'
        ];
        loadingStyle.innerHTML = style.join('');
        loadingMask.className = 'fit-loading';
        loadingMask.innerHTML = '<div class="loading-box"></div>';
        document.body.appendChild(loadingStyle);
        document.body.appendChild(loadingMask);
        resource.loadEssentialResource(opt.list || [], function() {
            setTimeout(function() {
                document.querySelector('.fit-loading').style.display = 'none';
            }, opt.delay || 0);
            if (loadedCb) {
                loadedCb();
            }
        }, function(percent) {
            if (loadingCb) {
                loadingCb(percent);
            }
        });
    };

    // 锁屏提示
    out.lockScreen = function(opt) {
        opt = opt || {};
        var lockScreenStyle = document.createElement('style');
        var lockScreenMask = document.createElement('div');
        var style = [
            '.fit-lock {',
            'position: fixed;',
            'top: 0;',
            'left: 0;',
            'width: 100%;',
            'height: 100%;',
            'background: ' + (opt.bg ? opt.bg : '#1a1a1a') + ';',
            'z-index: 99;',
            '}',
            '.fit-lock .fit-lock-box {',
            'position: absolute;',
            'top: 50%;',
            'left: 50%;',
            'color:' + (opt.color ? opt.color : '#9aa29b') + ';',
            'font-size: 14px;',
            'text-align: center;',
            'white-space: nowrap;',
            '-webkit-transform: translate(-50%, -50%);',
            '}',
            '.fit-lock .fit-lock-icon {',
            'margin: 0 auto 5px;',
            'width: 32px;',
            'height: 59px;',
            'background: url("//image.uc.cn/s/uae/g/01/fit/icon_lock.png") no-repeat;',
            'background-size: 32px 59px;',
            '}'
        ];
        lockScreenStyle.innerHTML = style.join('');
        lockScreenMask.className = 'fit-lock';
        lockScreenMask.innerHTML = '<div class="fit-lock-box"><div class="fit-lock-icon"></div><p>锁定屏幕旋转获得最佳体验</p></div>';
        document.body.appendChild(lockScreenStyle);
        document.body.appendChild(lockScreenMask);
        document.querySelector('.fit-lock').addEventListener('touchstart', function() {
            this.style.display = 'none';
        }, false);
    };

    return out;
}));
